import React, { ReactNode, useEffect, useRef } from "react";
import useWindowDimensions from "../../hooks/windowsSize";
import { cn } from "../../lib/utils";

interface CommonSplitContainerProps {
  topChild?: ReactNode;
  bottomChild?: ReactNode;
  currentHeight?: number;
  scrollToBottomTrigger?: boolean;
  scrollToTopTrigger?: boolean;
  onScrollPositionChange?: (atBottom: boolean) => void;
  overflowX?: any;
  scrollbarWidth?: any;
  containerClassName?: string;
}

const CommonSplitContainer: React.FC<CommonSplitContainerProps> = ({
  topChild,
  bottomChild,
  currentHeight = 0.91,
  scrollToBottomTrigger = false,
  scrollToTopTrigger = false,
  onScrollPositionChange,
  overflowX = "hidden",
  scrollbarWidth = "none",
  containerClassName
}) => {
  const { height } = useWindowDimensions();
  const containerRef = useRef<HTMLDivElement>(null);
  const handleScrollToBottom = () => {
    if (scrollToTopTrigger && containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  const handleScrollToTop = () => {
    if (scrollToBottomTrigger && containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
  };

  useEffect(() => {
    handleScrollToTop();
  }, [scrollToBottomTrigger]);

  useEffect(() => {
    handleScrollToBottom();
  }, [scrollToTopTrigger]);

  const handleScroll = () => {
    if (!containerRef.current || !onScrollPositionChange) return;
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    const atBottom = scrollTop + clientHeight >= scrollHeight - 50;
    onScrollPositionChange(atBottom);
  };

  return (
    <>
      <div
        ref={containerRef}
        style={{
          height: height * currentHeight - 80,
          overflowX: overflowX,
          scrollbarWidth: scrollbarWidth
        }}
        onScroll={handleScroll}
        className={cn("tw-p-5", containerClassName)}
      >
        {topChild}
      </div>
      {bottomChild}
    </>
  );
};

export default CommonSplitContainer;
